import {
  FccAdAlertType,
  TaskNotificationType,
} from '@backoffice-frontend/graphql'

export const adCallAlertTypes: FccAdAlertType[] = [
  FccAdAlertType.SafetyDriverCalling,
  FccAdAlertType.CabinToOperatorCall,
  FccAdAlertType.OperatorToCabinCall,
  FccAdAlertType.OutgoingOperatorToSafetyDriverCall,
  FccAdAlertType.IncomingSafetyDriverCall,
]

export const fleetMapAlertTypes = [
  TaskNotificationType.VehicleOutOfServiceAreaNotification,
  TaskNotificationType.VehicleNoBookingNotification,
  TaskNotificationType.VehicleNoHubReturnNotification,
  TaskNotificationType.VehicleWithoutDriverNotification,
  TaskNotificationType.VehicleLowStateOfChargeNotification,
  TaskNotificationType.FcVehicleOutOfServiceNotification,
]

export const adFleetMapAlertTypes = [
  TaskNotificationType.FcPassengerAuthenticationFallbackRequestNotification,
]

export const fleetControlAlertTypes = [
  ...fleetMapAlertTypes,
  ...adFleetMapAlertTypes,
]
